var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "h4 mb-1" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.dto.title) +
                "\n                "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "p-1 bg-white" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6 px-1" }, [
                _c("p", {
                  staticClass: "mb-0 fw-bold",
                  domProps: {
                    innerHTML: _vm._s(_vm.dto.recurringPriceDescriptionHtml),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 px-1" },
                [
                  _c("Price", {
                    attrs: {
                      price: _vm.dto.recurringPrice.price,
                      "initial-price": _vm.dto.recurringPrice.initialPrice,
                      "price-details": _vm.dto.recurringPrice.priceDetails
                        ? _vm.dto.recurringPrice.priceDetails
                        : undefined,
                      "show-from": _vm.dto.recurringPrice.showFrom,
                      "show-by-month": _vm.dto.recurringPrice.showByMonth,
                      "show-promo-duration":
                        _vm.dto.recurringPrice.showPromoDuration,
                      "show-end-of-promotion-price":
                        _vm.dto.recurringPrice.showEndOfPromotionPrice,
                      duration: _vm.dto.recurringPrice.duration,
                      "is-cents-format": false,
                      "is-compact": true,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.dto.internetDiscountEligibilityMessage
              ? _c("div", [
                  _c("p", { staticClass: "alert alert-info fw-normal" }, [
                    _c("span", {
                      staticClass: "alert-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "ob1-alert-title",
                      domProps: {
                        textContent: _vm._s(
                          _vm.dto.internetDiscountEligibilityMessage
                        ),
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.dto.onBillPrice
              ? _c("div", { staticClass: "row mt-1" }, [
                  _c("div", { staticClass: "col-6 px-1" }, [
                    _c("p", {
                      staticClass: "mb-0 fw-bold",
                      domProps: {
                        innerHTML: _vm._s(_vm.dto.onBillPriceDescriptionHtml),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 px-1" },
                    [
                      _c("Price", {
                        attrs: {
                          price: _vm.dto.onBillPrice.price,
                          "initial-price": _vm.dto.onBillPrice.initialPrice,
                          "price-details": _vm.dto.onBillPrice.priceDetails
                            ? _vm.dto.onBillPrice.priceDetails
                            : undefined,
                          "show-from": _vm.dto.onBillPrice.showFrom,
                          "show-by-month": _vm.dto.onBillPrice.showByMonth,
                          "show-promo-duration":
                            _vm.dto.onBillPrice.showPromoDuration,
                          "show-end-of-promotion-price":
                            _vm.dto.onBillPrice.showEndOfPromotionPrice,
                          duration: _vm.dto.onBillPrice.duration,
                          "is-cents-format": false,
                          "is-compact": true,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.dto.totalFeesPrice
              ? _c(
                  "div",
                  { staticClass: "row mt-1 d-flex align-items-baseline" },
                  [
                    _c("div", { staticClass: "col-6 px-1" }, [
                      _c("p", {
                        staticClass: "mb-0 fw-bold text-gray3",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.dto.totalFeesPriceDescriptionHtml
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-6 px-1" },
                      [
                        _vm.dto.totalFeesPrice.price === 0
                          ? [
                              _c("span", {
                                staticClass: "text-gray3",
                                domProps: {
                                  innerHTML: _vm._s(_vm.dto.freeFeesLabel),
                                },
                              }),
                            ]
                          : [
                              _c("Price", {
                                attrs: {
                                  price: _vm.dto.totalFeesPrice.price,
                                  "initial-price":
                                    _vm.dto.totalFeesPrice.initialPrice,
                                  "price-details": _vm.dto.totalFeesPrice
                                    .priceDetails
                                    ? _vm.dto.totalFeesPrice.priceDetails
                                    : undefined,
                                  "show-from": _vm.dto.totalFeesPrice.showFrom,
                                  "show-by-month":
                                    _vm.dto.totalFeesPrice.showByMonth,
                                  "show-promo-duration":
                                    _vm.dto.totalFeesPrice.showPromoDuration,
                                  "show-end-of-promotion-price":
                                    _vm.dto.totalFeesPrice
                                      .showEndOfPromotionPrice,
                                  duration: _vm.dto.totalFeesPrice.duration,
                                  "is-cents-format": false,
                                  "is-mini": true,
                                  custom: "text-gray3",
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dto.priceDetailsPopin
              ? _c(
                  "div",
                  [
                    _c("Lien", {
                      attrs: {
                        label: _vm.dto.priceDetailsPopin.linkLabel,
                        "is-button": true,
                        "is-link-arrow": true,
                        "data-test-id": "btn-price-detail",
                        "modal-id": "cart-recap-multiple-price-details",
                        "tms-category": "reprise_panier_avec_offre",
                        "tms-action": _vm.dto.priceDetailsPopin.linkLabel,
                        "tms-label": _vm.priceDetailsPopinTmsLabel,
                      },
                    }),
                    _vm._v(" "),
                    _c("MultiplePriceDetailsPopin", {
                      attrs: {
                        "modal-id": "cart-recap-multiple-price-details",
                        "price-details": _vm.dto.priceDetailsPopin,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { ref: "ctaBlock", staticClass: "mt-1 bg-white" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 px-1 d-flex flex-column align-items-center",
                },
                [
                  _vm.dto.doubleEquipmentAlertMessage
                    ? _c("div", [
                        _c("p", { staticClass: "alert alert-danger" }, [
                          _c("span", {
                            staticClass: "alert-icon",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "ob1-alert-title",
                            domProps: {
                              textContent: _vm._s(
                                _vm.dto.doubleEquipmentAlertMessage
                              ),
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dto.isDeviceOutOfStock
                    ? _c("div", [_vm._m(0)])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("CartPageOrderCta", {
                    attrs: {
                      dto: _vm.dto,
                      "is-disabled":
                        _vm.hasDoubleEquipmentOnCart ||
                        _vm.dto.isDeviceOutOfStock,
                    },
                  }),
                  _vm._v(" "),
                  _vm.dto.cartSharing
                    ? _c("CartPageSharing", {
                        attrs: {
                          "cart-description": _vm.dto.cartSharing.description,
                          "cart-url": _vm.dto.cartSharing.url,
                          "icon-from-svg": _vm.dto.cartSharing.iconFromSvg,
                          "authenticated-cart-message":
                            _vm.dto.cartSharing.authenticatedMessage,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isCtaOutOfViewport
            ? _c(
                "div",
                { staticClass: "p-1 bg-white fixed-bottom d-lg-none" },
                [
                  _c("CartPageOrderCta", {
                    attrs: {
                      dto: _vm.dto,
                      "is-disabled":
                        _vm.hasDoubleEquipmentOnCart ||
                        _vm.dto.isDeviceOutOfStock,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "alert alert-warning" }, [
      _c("span", {
        staticClass: "alert-icon",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "ob1-alert-title" }, [
        _vm._v(
          "Le terminal n'est plus disponible. Veuillez retirer le terminal de votre panier ou en choisir un autre."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }